// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 790) return "static/css/790.ca8176bba16f4e0007e6.lib.css";
	if (chunkId === 495) return "static/css/495.7588e11d14fdf5db8191.css";
	// return url for filenames based on template
	return undefined;
};